import { Button, Icon, Input, Radio, Select, Switch } from "antd";
import React, { useEffect, useState } from "react"
import style from "../solo.module.sass";
import { Http } from "../../../../../helpers/axois";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { logger } from "../../../../../constant/winston";
import variableAclIcon from "../../../../../assets/svg/solo/variableAclConfigured.svg"
import VariableAcl from "./VariableAcl";

const { Option } = Select

type Inputvars = {
    key: string,
    value: string
    type?: string
}

const AiAgent = (props: any) => {
    const { widgetDrawer,
        nameCheck,
        lock,
        setWidgetDrawer,
        onUpdateProperties,
        nodeDetail,
        elements,
        showVariableAcl,
        setAclIcon,
        setShowVariableAcl,
        form
    } = props || {};
    const { propertyDetails } = nodeDetail?.data || {}
    const [name, setName] = useState<string>("");
    const [inputQuery, setInputQuery] = useState<string>("");
    const [outputVariable, setOutputVariable] = useState<string>("");
    const [nodes, setNodes] = useState<any[]>()
    const [nextNode, setNextNode] = useState<string>("")
    const [inputvars, setInputvars] = useState<Inputvars[]>([])
    const [outputVars, setOutputvars] = useState<Inputvars[]>([])
    const [enableDestructure, setEnableDestructure] = useState<boolean>(false)
    const pathname = useLocation().pathname
    const locationSplit = pathname.split('/');
    const appId = locationSplit[3];
    const [variableAcl, setVariableAcl] = useState({});
    const [setupActiveTab, setSetupActiveTab] = useState("freeze")
    const [teardownActiveTab, setTeardownActiveTab] = useState("freeze")
    const [selectedForm, setSelectedForm] = useState(null);
    const [formKey, setFormKey] = useState(null)
    const currentBranch: any = useSelector((state: any) => {
        const selectedAppId = state.apps.selectedApp && state.apps.selectedApp.id
        return (state.apps.appBranch && state.apps.appBranch[selectedAppId]) || {}
    }, (left: any, right: any) => left.branchId === right.branchId)
    const versionId = useSelector((state: any) => {
        return appId && state.apps.appVersion[appId].versionId
    })
    const branchId = currentBranch && currentBranch.branchId

    const nextNodeId = (): string => {
        const findNextNode = elements.filter((el: any) => { return (el.source === nodeDetail.id) })
        if (findNextNode.length) {
            //const nextNode = elements.filter((el: any) => { return el.id === findNextNode[0].target })
            return (findNextNode[0].target)
        } else {
            return ("")
        }
    }

    useEffect(() => {
        const findNextNode = elements.filter((el: any) => { return (el.source === nodeDetail?.id) })
        const targetNodeFind = elements.filter((el: any) => { return (el.target === nextNode) })
        if (findNextNode.length) {
            setNextNode(findNextNode[0].target)
        } else if (findNextNode.length === 0 && targetNodeFind.length === 0) {
            setNextNode("")
        }
        let arr: any = []
        elements.forEach((e: any) => {
            if (e.data && e.data.type && e.data.type !== "start" && e.data.type !== "error" && e.id !== nodeDetail?.id) {
                arr.push(e)
            }
        })
        setNodes(arr)
    }, [elements])

    useEffect(() => {
        const fetchAndSetVars = async () => {
            setShowVariableAcl(false)
            if (!propertyDetails) {
                setInputQuery("")
                setInputvars([])
                setOutputvars([])
                setNextNode(nextNodeId())
                return
            }
            const response = await fetchAgents();
            const { agentInputVariables = [], agentOutputVariables = [] } = response || {};
            const {
                inputQuery = "",
                outputVariable = [],
                inputVariable = [],
                enableDestructure = false,
                selectedAgent = false,
                selectedAgentOutputVariable = [],
                selectedAgentInputVariable = [],
                responseBind = "", aiAgentKey, variableAcl = {}, formKey = "" } = propertyDetails || {}
                
            if(formKey){
                form && form.forEach((f: any) => {
                    if (f.formKey === formKey) {
                        setSelectedForm(f.displayName)
                    }
                })
            }
                
            const agentInputVars = Array.isArray(agentInputVariables)
                ? agentInputVariables.reduce((acc: any, curr: any) => {
                    acc[curr] = "";
                    return acc;
                }, {}) : {}

            const inputVaraiblesList = Array.isArray(inputVariable)
                ? inputVariable.reduce((acc: any, curr: any) => {
                    acc[curr.key] = curr.value;
                    return acc;
                }, {}) : inputVariable

            const finalInputVars = matchParams(inputVaraiblesList, agentInputVars)

            if (variableAcl?.setup?.freeze || variableAcl?.setup?.unfreeze ||
                variableAcl?.setup?.hide || variableAcl?.setup?.unhide ||
                variableAcl?.teardown?.freeze || variableAcl?.teardown?.unfreeze ||
                variableAcl?.teardown?.hide || variableAcl?.teardown?.unhide) {
                setAclIcon(variableAclIcon)
            }

            if (aiAgentKey) {
                if (!selectedAgent) {
                    setVariableAcl(nodeDetail.data.propertyDetails?.variableAcl || {})
                    setInputQuery(inputQuery)
                    setNextNode(nextNodeId())
                    setInputvars(Object.entries(finalInputVars).map(([key, value]) => ({
                        key,
                        value: String(value),
                    })));

                    setEnableDestructure(enableDestructure ? enableDestructure : typeof responseBind === "string" ? false : true)

                    if (typeof responseBind !== "string") {
                        const outputResp = responseBind ? (Object.entries(responseBind).map(([key, value]) => ({
                            key: String(value),
                            value: key,
                            type: ""
                        }))) : Array.isArray(outputVariable) ? outputVariable : []
                        
                        if (agentOutputVariables?.length > 0) {
                            const result = agentOutputVariables.map((output) => {
                                const matchingOutput = outputResp?.find((out: any) => output.name === out.key);

                                return matchingOutput
                                ? {
                                    key: matchingOutput.key,
                                    value: matchingOutput.value,
                                        type: matchingOutput.type,
                                    }
                                    : {
                                        key: output.name,
                                        value: "",
                                        type: output.type,
                                    };
                                });
                                
                                setOutputVariable(responseBind && typeof responseBind === "string" ? responseBind : typeof outputVariable === "string" ? outputVariable : "")
                                setOutputvars(result)
                        } else {
                            setOutputvars(outputResp?.length > 0 ? outputResp : [])
                            setOutputVariable(responseBind && typeof responseBind === "string" ? responseBind : typeof outputVariable === "string" ? outputVariable : "")
                        }

                    }else{
                        const result = agentOutputVariables.map((output) => {
                            const matchingOutput = Array.isArray(outputVariable) ? outputVariable?.find((out: any) => output.name === out.key) : null;

                            return matchingOutput
                                ? {
                                    key: matchingOutput.key,
                                    value: matchingOutput.value,
                                    type: matchingOutput.type,
                                }
                                : {
                                    key: output.name,
                                    value: "",
                                    type: output.type,
                                };
                        });
                        setOutputvars(result)
                        setOutputVariable(responseBind && typeof responseBind === "string" ? responseBind : typeof outputVariable === "string" ? outputVariable : "")
                    }
                    return
                }

                setVariableAcl(nodeDetail.data.propertyDetails?.variableAcl || {})
                setFormKey(formKey)
                setInputQuery(inputQuery)
                setNextNode(nextNodeId())
                const { inputVariablesList, outputVariablesList } = findInputandOutputVariables(selectedAgent ? [] : inputVariable, selectedAgentInputVariable, agentInputVariables, selectedAgentOutputVariable, agentOutputVariables, outputVars)
                // Set the input and output variables
                setEnableDestructure(selectedAgent ? false : enableDestructure)
                setInputvars(inputVariablesList);
                setOutputVariable("")
                setOutputvars(outputVariablesList);
                return
            }
            
            setFormKey(formKey)
            setInputQuery(inputQuery)
            setInputvars(inputVariable)
            setOutputvars(outputVariable)
            setOutputVariable(outputVariable)
            setVariableAcl(nodeDetail.data.propertyDetails?.variableAcl || {})
            setEnableDestructure(enableDestructure)
            setNextNode(nextNodeId())
            return
        }

        setName(propertyDetails?.name || nodeDetail?.id);
        fetchAndSetVars();
    }, [nodeDetail.id, widgetDrawer])

    useEffect(() => {
        if (form) {
            form.forEach((f: any) => {
                if (f.displayName === selectedForm) {
                    setFormKey(f.formKey)
                }
            })
        }
    }, [selectedForm])

    function findInputandOutputVariables(inputVariable: any, selectedAgentInputVariable: any, agentInputVariables: any, selectedAgentOutputVariable: any, agentOutputVariables: any, outputVars: any) {
        let inputVariablesList = [];
        let outputVariablesList: any = [];

        if (Array.isArray(selectedAgentInputVariable) && selectedAgentInputVariable?.length > 0) {
            inputVariablesList = selectedAgentInputVariable.map((el) => ({ key: el, value: "" }));
        } else if (inputVariable && Array.isArray(inputVariable) && inputVariable?.length > 0 && agentInputVariables.length > 0) {
            inputVariablesList = inputVariable;
        } else if (Object.keys(inputVariable || {}).length > 0 && agentInputVariables?.length > 0) {
            inputVariablesList = Object.entries(inputVariable || {}).map(([key, value]) => ({
                key,
                value: String(value),
            }));
        } else if (Array.isArray(agentInputVariables) && agentInputVariables?.length > 0) {
            inputVariablesList = agentInputVariables.map((el) => ({ key: el, value: "" }));
        }

        if (Array.isArray(selectedAgentOutputVariable) && selectedAgentOutputVariable?.length > 0) {
            outputVariablesList = selectedAgentOutputVariable.map((el) => ({ key: el.name, value: "", type: el.type }));
        } else if (Object.keys(outputVars || {}).length > 0 && agentOutputVariables?.length > 0) {
            outputVariablesList = Object.entries(outputVars || {}).map(([key, value]) => ({
                key: value,
                value: String(key),
            }));
        } else if (outputVars && Array.isArray(outputVars) && outputVars?.length > 0 && agentOutputVariables?.length > 0) {
            outputVariablesList = outputVars;
        } else if (Array.isArray(agentOutputVariables) && agentOutputVariables?.length > 0) {
            outputVariablesList = agentOutputVariables.map((el) => ({ key: el.name, value: "", type: el.type }));
        }

        return {
            inputVariablesList,
            outputVariablesList
        }
    }

    function matchParams(params1: any, params2: any) {
        const result: any = {};

        for (const key in params2) {
            result[key] = key in params1 ? params1[key] : params2[key];
        }
        return result;
    }

    const fetchAgents = async () => {
        let response: { agentInputVariables: string[], agentOutputVariables: any[] } = {
            agentInputVariables: [],
            agentOutputVariables: []
        }
        try {
            const res: any = await Http.get(`/apps/${appId}/ai-agents?branchId=${branchId}&versionId=${versionId}`).toPromise()
            if (res?.aiAgents) {
                const key = (propertyDetails.aiAgentKey)
                const findAgent = res.aiAgents.filter((el: any) => { return el.aiAgentKey === key })
                if (findAgent?.length > 0) {
                    const { inputVars: inputVariables = [], outputParams = [] } = findAgent[0] || {}
                    response.agentInputVariables = inputVariables
                    response.agentOutputVariables = outputParams
                }
            }
            return response
        } catch (err) {
            logger.error("error", err)
            return response
        }
    }

    const handleInputChange = (key: string, newValue: string) => {
        setInputvars((prevInputvars) =>
            prevInputvars.map((vars) =>
                vars.key === key ? { ...vars, value: newValue } : vars
            )
        );
    };

    const handleOutputChange = (key: string, newValue: string) => {
        setOutputvars((prevInputvars) =>
            prevInputvars.map((vars) =>
                vars.key === key ? { ...vars, value: newValue } : vars
            )
        );
    };

    const saveChanges = () => {
        const aiAgentProperties = {
            nodeId: nodeDetail.id,
            name: name,
            inputQuery,
            outputVariable: enableDestructure ? outputVars : outputVariable,
            inputVariable: inputvars,
            enableDestructure,
            nextNode,
            aiAgentKey: propertyDetails?.agentKey || propertyDetails?.aiAgentKey || "",
            idChange: true,
            variableAcl,
            formKey
        }

        setWidgetDrawer(false)
        onUpdateProperties(aiAgentProperties)
    }

    return (
        <>
            {!showVariableAcl ?
             <>
                <div style={{ display: "flex", flexDirection: "column" }} >
                    <div className={style.conditionInput}>
                        <div style={{ width: "100%" }}>
                            <div className={style.label}>
                                <label >Name</label>
                            </div>
                            <Input
                                disabled={lock}
                                style={{ width: "100%", height: "44px", color: "#000610", fontSize: 15, border: nameCheck ? "1px solid #FF0000" : "1px solid #909BAD" }}
                                value={name}
                                placeholder="Enter Node Name"
                                onChange={(e: any) => { setName(e.target.value); }}
                            />
                            {(nameCheck || !name) && <p style={{
                                color: "#FF0000",
                                opacity: nameCheck || !name ? 1 : 0,
                                position: "relative",
                                textAlign: "center",
                                margin: "5px",
                                fontSize: 14
                            }}>{!name ? "Name shouldn't be empty" : "Name already exist"}</p>}
                        </div>
                    </div>
                    <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>
                </div>
                <div style={{ display: "flex", flexDirection: "column" }} >
                    <div className={style.conditionInput}>
                        <div style={{ width: "100%" }}>
                            <div className={style.label}>
                                <label >Input Query</label>
                            </div>
                            <Input
                                disabled={lock}
                                style={{ width: "100%", height: "44px", color: "#000610", fontSize: 15, border: "1px solid #909BAD" }}
                                value={inputQuery}
                                required={true}
                                placeholder="eg: get_weather"
                                onChange={(e: any) => { setInputQuery(e.target.value); }}
                            />
                        </div>
                    </div>
                </div>
                <div style={{ maxHeight: window.innerHeight - 410, overflow: "auto" }}>
                    <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "0px 15px" }}>
                        <div
                            className={style.label}
                            style={{ color: "#3c434a" }}
                        >
                            <label >Next Node</label>
                        </div>
                        <Select
                            showSearch
                            onChange={(e: any) => setNextNode(e)}
                            suffixIcon={<Icon style={{ fontSize: "20px", margin: -5 }} type="caret-down" />}
                            disabled={lock}
                            value={nextNode || undefined}
                            placeholder="Select the next node"
                            optionLabelProp="label"
                            style={{
                                width: "100%",
                                borderRadius: 8,
                                color: "#000610",
                                fontSize: 15
                            }}
                            mode="default"
                            size="large"
                            filterOption={(input, option: any) => {
                                return (option && option.props)
                                    ?
                                    option.label.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    : false
                            }}
                        >
                            {nodes && nodes.map((el: any) => {
                                return <Option
                                    key={el.id}
                                    value={el.id}
                                    label={el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name || el.id}>
                                    <div
                                        style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <div
                                            style={{ display: "flex", flexDirection: "row" }}>
                                            <img alt="icons" src={el.data.icon} />
                                            <p
                                                style={{
                                                    marginLeft: "8px",
                                                    marginTop: "14px",
                                                    color: el.id === nextNode ? "#0F66C8" : "#000610"
                                                }}
                                            >
                                                {el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name || el.id}
                                            </p>
                                        </div>
                                        {el.id === nextNode &&
                                            < Icon type="check" style={{ color: "#0F66C8" }} />}
                                    </div>
                                </Option>
                            })}
                        </Select>
                    </div>

                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "5px 15px" }}>
                            <div className={style.label} >
                                <label> Waiting Form Screen</label>
                            </div>
                            <Select
                                showSearch
                                suffixIcon={<Icon style={{ fontSize: "20px", margin: "-5px" }} type="caret-down" />}
                                disabled={props.lock}
                                placeholder="Select the form"
                                value={selectedForm || undefined}
                                size="large"
                                style={{
                                    width: "100%",
                                    borderRadius: 8,
                                    //border: "1px solid #CAD5E9",
                                    color: "#000610",
                                    fontSize: 15,
                                }}
                                optionLabelProp="label"
                                onChange={(e: any) => setSelectedForm(e)}
                                filterOption={(input, option: any) => {
                                    return (option && option.props && option.props.children) ?
                                        option.props.children.props.children[0].props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        : false
                                }}
                            >
                                {form && form.map((item: any) => {
                                    return <Option
                                        key={item.formId}
                                        value={item.displayName}
                                        label={item.displayName}>
                                        <div
                                            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <p style={{ marginTop: "10px", color: item.displayName === selectedForm ? "#0F66C8" : "#000610" }}>
                                                {item.displayName}
                                            </p>
                                            {item.displayName === selectedForm &&
                                                < Icon type="check" style={{ color: "#0F66C8" }} />}
                                        </div>
                                    </Option>
                                })}
                            </Select>
                        </div>
                    {inputvars?.length > 0 && <div>
                        <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "0px 15px" }}>
                            <div
                                className={style.label}
                                style={{ color: "#3c434a" }}
                            >
                                <label >Input Variables</label>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                {inputvars?.map((vars) => {
                                    return (
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                                            <div
                                                title={vars.key}
                                                style={{ width: 115, color: "#000610", fontWeight: 500, fontSize: 14, textOverflow: "ellipsis", overflow: "hidden"}} 
                                            >{vars.key}</div>
                                            <Input 
                                                disabled={lock}
                                                placeholder="Enter value" value={vars.value} style={{ height: 44, width: 186, border: "1px solid #909BAD", color: "#000610", fontSize: 14 }}
                                                onChange={(e) => handleInputChange(vars.key, e.target.value)} />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>}
                    <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>
                    <div>
                        <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "0px 15px" }}>
                            <div
                                className={style.label}
                                style={{ color: "#3c434a" }}
                            >
                                <label >Output Variables</label>

                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <label style={{ color: "#000000", fontSize: 14, paddingRight: 8}}>Structured Data</label>
                                    <Switch disabled={lock} defaultChecked={enableDestructure} checked={enableDestructure} onChange={(e: any) => {
                                         setEnableDestructure(e); 
                                    }} />
                                </div>
                            </div>
                            {enableDestructure && <div style={{ display: "flex", flexDirection: "column", paddingTop: 5 }}>
                                {outputVars?.map((vars) => {
                                    return (
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                                            <div 
                                                title={vars.key}
                                                style={{ width: 115, color: "#000610", fontWeight: 500, fontSize: 14, textOverflow: "ellipsis", overflow: "hidden"}} 
                                            >{vars.key}</div>

                                            <Input disabled={lock} placeholder="Enter value" value={vars.value} style={{ height: 44, width: 186, border: "1px solid #909BAD", color: "#000610", fontSize: 14 }} onChange={(e) => { handleOutputChange(vars.key, e.target.value) }} />
                                        </div>
                                    )
                                })}
                            </div>}
                            {!enableDestructure && <div style={{ display: "flex", flexDirection: "column" }}>
                                <Input
                                    disabled={lock}
                                    style={{ width: "100%", height: "44px", color: "#000610", fontSize: 15, border: "1px solid #909BAD" }}
                                    value={outputVariable}
                                    placeholder="Output variable"
                                    onChange={(e: any) => { setOutputVariable(e.target.value); }}
                                />
                            </div>}
                        </div>
                    </div>
                </div>
            </>
                : <VariableAcl
                    variableAcl={variableAcl}
                    setVariableAcl={setVariableAcl}
                    teardownActiveTab={teardownActiveTab}
                    setTeardownActiveTab={setTeardownActiveTab}
                    setupActiveTab={setupActiveTab}
                    setSetupActiveTab={setSetupActiveTab}
                    setShowVariableAcl={setShowVariableAcl}
                    name={name}
                    lock={props.lock}>
                </VariableAcl> 
        }
            {<div className={style.footer}>
                {!nameCheck && !lock && <Button
                    disabled={!name}
                    style={{
                        backgroundColor: "#51808C",
                        color: "#FFFFFF",
                        width: "100%",
                        height: 50
                    }}
                    onClick={() => { saveChanges() }} >APPLY</Button>}
            </div>}
        </>
    )
}

export default AiAgent